import { component as defineComponent } from 'flightjs';
import withAsyncValidation from 'launch/modules/mixins/with-async-validation';
import Spinner from 'app/modules/button-spinner';
import { get as getCookie } from 'cookies-js';

var lang = {
    enterEmail: 'Please enter an email address',
    enterPassword: 'Please enter a password',
    passwordMismatch: 'Password fields must match',
    invalidEmail: 'Your email address is invalid',
    invalidPassword: '',
    emailTaken: 'This email address is taken',
    genericError: 'Unable to register, please try again',
};

function RegistrationForm() {
    this.attributes({
        submitSelector: '[type="submit"]',
        emailSelector: '#registrationform_email',
        passwordSelector: '#registrationform_password_first',
        passwordConfirmSelector: '#registrationform_password_second',
        context: 'launch',
    });

    this.submitClicked = function(e) {
        e.preventDefault();
        this.resetValidationErrors();

        var $email = this.select('emailSelector');
        var $password = this.select('passwordSelector');
        var $confirmPassword = this.select('passwordConfirmSelector');

        if (!$email.val()) {
            this.displayErrorsForField($email, lang.enterEmail);
            return;
        }

        if (!$password.val()) {
            this.displayErrorsForField($password, lang.enterPassword);
            return;
        }

        if ($password.val() !== $confirmPassword.val()) {
            this.displayErrorsForField($confirmPassword, lang.passwordMismatch);
            return;
        }

        this.trigger('spinnerStart');

        var data = {
            email: this.select('emailSelector').val(),
            password: this.select('passwordSelector').val(),
            context: this.attr.context,
            csrf_token: getCookie('_99csrf'),
        };

        this.trigger('uiUserRegistrationRequested', data);
    };

    this.handleRegistrationSuccess = function(ev, data) {
        this.trigger('spinnerStop');
        this.trigger('registrationSuccessful');
    };

    this.handleRegistrationFailure = function(ev, data) {
        var $email = this.select('emailSelector');
        var $password = this.select('passwordSelector');
        var errors = {};

        if (data && data.errors) {
            errors = this.formErrors(data.errors);
        }

        this.trigger('spinnerStop');

        if (errors.email) {
            this.displayErrorsForField($email, errors.email);
        } else if (errors.password) {
            this.displayErrorsForField($password, errors.password);
        } else {
            this.displayErrorsForField($email, lang.genericError);
        }
    };

    this.formErrors = function(errors) {
        var fieldErrors = {};

        if (!errors) {
            return fieldErrors;
        }

        errors.forEach(function(error) {
            if (!fieldErrors[error.param]) {
                fieldErrors[error.param] = error.message;
            }
        });

        return fieldErrors;
    };

    this.prePopulateEmail = function(e, data) {
        this.select('emailSelector').val(data.value);
    };

    this.after('initialize', function() {
        this.select('emailSelector')
            .parents('.field')
            .append('<div id="email-suggestion-container" class="field__message" />');
        this.select('emailSelector').setupMailCheck('#email-suggestion-container');

        Spinner.attachTo(this.select('submitSelector'));

        this.on('click', {
            submitSelector: this.submitClicked,
        });

        this.on(document, 'uiBriefEmailBeforeSignupChanged', this.prePopulateEmail);
        this.on(document, 'dataUserRegistrationSuccess', this.handleRegistrationSuccess);
        this.on(document, 'dataUserRegistrationFailure', this.handleRegistrationFailure);
    });
}

export default defineComponent(RegistrationForm, withAsyncValidation);



// WEBPACK FOOTER //
// ./src/web/js/launch/modules/registration-form.js